module.exports = __webpack_public_path__ + "img/andreev.30990805.png";